const GlobalVariables = {
	FrontendVersion: undefined,
};

(window as any).ESGIGlobalVariables = GlobalVariables;
export default GlobalVariables;
